/**
 * Compose a child route path relative to a parent match path.
 *
 * Used when nesting `<Route>` components under a parent route so that each
 * sub-flow (`FreePackagesContent`, `FriendsAndFamilyContent`, `PurchaseProductsContent`)
 * can reuse its relative `routes.ts` entries without hardcoding the parent segment.
 *
 * Examples:
 *   childPath("/dla-bliskich", "/katalog-badan") === "/dla-bliskich/katalog-badan"
 *   childPath("/dla-bliskich", "/")              === "/dla-bliskich"
 *   childPath("/", "/katalog-badan")             === "/katalog-badan"
 */
export const childPath = (parentPath: string, relative: string): string => {
  if (parentPath === "/") return relative;
  return relative === "/" ? parentPath : `${parentPath}${relative}`;
};
